import type { Agent, AgentMood } from "@/shared/types";

// Relative-age strings ("just now", "3h", "1d", "2w", "2mo") → minutes, for
// recency sorting. Unknown/missing ages sink to the bottom (1e9, not Infinity —
// Infinity - Infinity is NaN and breaks sort comparators).
const AGE_UNITS: Record<string, number> = { m: 1, h: 60, d: 1440, w: 10080, mo: 43200, y: 525600 };
export function ageMinutes(s: string | null | undefined): number {
  if (!s) return 1e9;
  if (/just now|^now/.test(s)) return 0;
  const m = s.match(/(\d+)\s*(mo|[mhdwy])/);
  return m ? +m[1] * AGE_UNITS[m[2]] : 1e9;
}

// Agent emotion, shown on the pixel avatar. A heuristic over the chat list —
// a backend-derived state would replace it:
//   angry    — an active run is stuck waiting on human approval
//   sad      — abandoned: the user hasn't chatted in months (or never, for
//              agents the user built themselves)
//   sleeping — idle: no activity for weeks
//   happy    — everything is fine
export function agentMood(agent: Agent | null | undefined): AgentMood | null {
  if (!agent) return null;
  const chats = agent.chats || [];
  if (chats.some((c) => c.isRun && !c.archived)) return "angry";
  const latest = chats.find((c) => !c.archived);
  if (!latest) return "sad";
  if (/mo|y/.test(latest.updatedAt)) return "sad";
  if (/\d\s*w/.test(latest.updatedAt)) return "sleeping";
  return "happy";
}
